export default __webpack_public_path__ + "images/U2.e6de3be.png";